<template>
  <div id="app">
    <el-row style="min-height:100%">
      <el-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12, offset: 6 }" :lg="{ span: 8, offset: 8 }"
        style="min-height:100%">
        <router-view />
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  created() {
    // if (this.$store.getters.user == null){
    //   this.$store.dispatch("user/getInfo").then(res => {
    //     // console.log("载入用户信息",res)
    //   })
    // }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  /*margin-top: 60px;*/
}

html,
body {
  padding: 0;
  margin: 0;
  height: 100%;
  box-sizing: border-box;
  background: #DDD;
}

a {
  text-decoration: none
}
</style>



// WEBPACK FOOTER //
// src/App.vue